import { Row, Col, Card, Button } from "react-bootstrap"
import ImageGallery from 'react-image-gallery';
import { useTranslation } from 'react-i18next';

import { RoleEnum, VehicleEntity } from "../../api";
import { useAuth } from "../../hooks/useAuth";
import { translateVehicleStates } from "../../utils/translations";
import { changeHorizonSpainToHorizon, toHttps } from "../../utils";



const VehicleCardBody = ({ showLinkBtn = false, showState = false, data, children }: {
    showLinkBtn?: boolean,
    showState?: boolean,
    data: VehicleEntity,
    children?: JSX.Element
}) => {
    const { userRole, canViewPromoNote } = useAuth();
    const { t } = useTranslation()


    return (
        <Card.Body>
            <Row>
                <Col lg={6}>
                    <ImageGallery
                        lazyLoad={true}
                        showNav={false}
                        onErrorImageURL={
                            '/images/placeholder.png'
                        }
                        showPlayButton={false}
                        items={
                            data?.image_list?.length
                                ? data?.image_list?.map((item: any) => ({
                                    original: toHttps(item?.url),
                                    thumbnail: toHttps(item?.url),
                                }))
                                : [{ original: '', thumbnail: '' }]
                        }
                    />
                </Col>
                <Col lg={6}>
                    <Row>
                        <Col xs={12}>
                            <div className="h2">
                                {data?.dati_veicolo?.marca}{' '}
                                {data?.dati_veicolo?.modello}
                            </div>
                            <p className="fs-4">
                                {data?.dati_veicolo?.allestimento}
                            </p>

                            {showState && (
                                <div>
                                   {t('state')}: <b>{translateVehicleStates(data.stato_corrente?.type || '')}</b>
                                   </div>
                            )}

                            {showLinkBtn && data.id && (
                                <div className="mt-3">
                                    <Button href={`/details/${data.id}`}>{t('visualize_veicolo')}</Button>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <hr />

                    <Row>
                        <Col sm={5}>
                            {data?.dettagli_veicolo && (
                                <>
                                    <ul className="primary-list">
                                        <li>{data?.dati_veicolo?.cambio}</li>
                                        <li>{data?.dati_veicolo?.motore}</li>
                                        <li>{data?.dati_veicolo?.alimentazione}</li>
                                    </ul>
                                    <div className="renter-name">
                                        {userRole !== RoleEnum.FLEET_MANAGER ?
                                            <div>
                                                <div className="label">{t('auto_dealership')}:</div>
                                                <div className="value">
                                                    {changeHorizonSpainToHorizon(data?.dettagli_veicolo?.dealer?.replace('_', ' ') || "")}
                                                </div>
                                            </div>
                                            : ""}
                                        {/* Il nome noleggiatore da mettere qui è quello che offre l'offerta corrispondente al canone minimo */}
                                    </div>
                                </>
                            )}
                        </Col>

                        {children}
                    </Row>

                    {canViewPromoNote && data?.dettagli_veicolo?.promo_note ? (
                        <Row>
                            <Col>
                                <hr />
                                <small className="mt-2 d-block fw-bold" style={{ fontSize: 20 }}>
                                    {data?.dettagli_veicolo.promo_note}
                                </small>
                            </Col>
                        </Row>
                    ) : ('')}
                </Col>
            </Row>
        </Card.Body>
    )
}

export default VehicleCardBody;
